(function($) {
  'use strict';

  const featuredGallery = {
    dom: function() {
      this.$homeGallery = $('#homeGallery');
      this.$homeGalleryTitle = $('#homeGalleryTitle');
    },

    initialize: function() {
      this.$homeGallery.addClass('owl-carousel owl-theme').owlCarousel({
        nav: false,
        dots: true,
        items: 1,
        stagePadding: 0,
        navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5.61,7.19c.16,0,.31.05.45.14.13.09.23.22.29.36.06.15.07.31.04.47-.03.16-.11.3-.23.41l-2.63,2.63h18.87c.11,0,.21.02.31.06.1.04.19.1.26.17.08.07.14.16.18.26.04.1.06.2.06.31s-.02.21-.06.31c-.04.1-.1.19-.18.26-.08.07-.17.13-.26.17-.1.04-.2.06-.31.06H3.53l2.63,2.63c.08.07.14.16.18.26.04.1.06.2.07.31,0,.11-.02.21-.06.31-.04.1-.1.19-.17.26s-.16.13-.26.17c-.1.04-.2.06-.31.06-.11,0-.21-.02-.31-.07-.1-.04-.19-.1-.26-.18l-3.93-3.93c-.1-.07-.18-.17-.23-.28-.05-.11-.08-.23-.08-.35,0-.12.03-.24.08-.35.05-.11.13-.21.23-.28,0,0,0,0,0,0l3.93-3.93c.07-.08.16-.14.26-.18.1-.04.2-.06.31-.06Z" stroke-width="0"/></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M18.39,16.81c-.16,0-.31-.05-.45-.14-.13-.09-.23-.22-.29-.36-.06-.15-.07-.31-.04-.47.03-.16.11-.3.23-.41l2.63-2.63H1.6c-.11,0-.21-.02-.31-.06-.1-.04-.19-.1-.26-.17-.08-.07-.14-.16-.18-.26-.04-.1-.06-.2-.06-.31s.02-.21.06-.31c.04-.1.1-.19.18-.26.08-.07.17-.13.26-.17.1-.04.2-.06.31-.06h18.87l-2.63-2.63c-.08-.07-.14-.16-.18-.26-.04-.1-.06-.2-.07-.31,0-.11.02-.21.06-.31.04-.1.1-.19.17-.26s.16-.13.26-.17c.1-.04.2-.06.31-.06.11,0,.21.02.31.07.1.04.19.1.26.18l3.93,3.93c.1.07.18.17.23.28.05.11.08.23.08.35,0,.12-.03.24-.08.35-.05.11-.13.21-.23.28,0,0,0,0,0,0l-3.93,3.93c-.07.08-.16.14-.26.18-.1.04-.2.06-.31.06Z" stroke-width="0"/></svg>'],
        responsive: {
          809: {
            nav: true,
            dots: false,
          }
        },
        onChange: function(event) {
          if (event.property.name != 'position') { return; }

          let $carousel = $(event.target);
          let $slides = $carousel.find('.homepage__gallery-item');
          let $slide = $slides.eq(event.property.value);
          let $image = $slide.find('[data-manual-src]');
          if ($image.length && !$image.data('loaded')) {
            $image.attr('src', $image.data('manual-src')).data('loaded', 1);
          }
        },
        onChanged: function(event) {
          let $carousel = $(event.target);
          let $slides = $carousel.find('.homepage__gallery-item');
          let $slide = $slides.eq(event.property.value);

          featuredGallery.$homeGalleryTitle.text($slide.data('title'));
        }
      });
    },

    ready: function() {
      this.dom();
      this.initialize();
    }
  };

  $(function() { featuredGallery.ready(); });

})(jQuery);
